import BreakpointHelper from "../helpers/BreakpointHelper";

Vue.asyncComponent('bp-skin-settings', {
    data() {
        return {
            previewScale: 1,
            loading: false,
            dataProvider: null,
            breakpoints: [],
            activeBreakpointId: null,
            previewIframe: null,
            settings: {},
            iframeLoaded: false,
            showPreview: true,
            sideBarWidth: null,
            showSettings: false,
            settingsFormFullWidth: false,
            setShowSettingsDebounced: null,
        }
    },
    props: {
        blueprintId: {
            type: String|Number,
        },
        verticalId: {
            type: String|Number,
        },
        queryParams: {
            type: Object,
        },
        dataProviderClass: {
            type: Function,
        }
    },
    computed: {
        previewUrl() {
            return this.dataProvider.getSkinSettingsHandler().getPreviewUrl(this.verticalId, this.blueprintId)
        },
    },
    methods: {
        /**
         * Set the settings for iframe
         * @param settings
         */
        async setSettingsForIframe(settings) {
            if (! this.iframeLoaded) {
                return;
            }

            this.settings = settings;
            this.loading = true;

            const request = await fetch(this.previewUrl, {
                method: 'POST',
                body: JSON.stringify(this.settings),
                headers: {
                    'X-CSRF-Token': this.$getSetting('security.csrfToken')
                }
            });

            // Get the html from the post request
            const body = await request.text();

            // Update the iframe's content width it
            this.$refs.iframe[0].contentWindow.document.documentElement.innerHTML = body;

            // init dom
            if (this.$refs.iframe[0].contentWindow.initDom) {
                this.$refs.iframe[0].contentWindow.initDom(this.$refs.iframe[0].contentWindow.document.documentElement);
            }

            this.loading = false;
        },
        /**
         * Save the form settings
         * @returns {Promise<void>}
         */
        async saveSettings() {
            this.loading = true;
            const url = this.dataProvider.getSkinSettingsHandler().getSaveSkinSettingsUrl(this.verticalId);

            const body = { "formValues": { ...this.settings }};
            const result = await this.$post(url, body);
            this.loading = false;

            if (result.success) {
                this.$actionHandler.handle(result.todos, this);
            }
        },
        /**
         * Set the iframe loaded state
         * @param loaded
         */
        setIframeLoaded(loaded) {
            this.iframeLoaded = loaded;
        },
        /**
         * Get the width for the given breakpoint
         * @param breakpoint
         * @returns {string}
         */
        getBreakpointWidth(breakpoint) {
            return BreakpointHelper.getBreakpointWidth(breakpoint);
        },
        /**
         * Set the new preview scale
         */
        setPreviewScale(scale) {
            this.previewScale = scale;
            this.$refs.iframe[0].contentWindow.document.documentElement.style.zoom = scale;
        },
        /**
         * Set the side bar width
         * @param width
         */
        setSideBarWidth(width) {
            this.sideBarWidth = width;
            localStorage.setItem('bp-skin-settings-side-bar-width', width);
        },
        /**
         * Check if we have a sidebar width in settings if so use it
         */
        setSideBarWidthFromStorage() {
            const width = localStorage.getItem('bp-skin-settings-side-bar-width');

            if (width) {
                this.sideBarWidth = width;
            }
        },
        /**
         * Set the side bar width
         * @param width
         */
        toggleSideBarFullWidth() {
            if (this.showPreview) {
                this.setSideBarWidthFromStorage();
                this.settingsFormFullWidth = false;
            } else {
                this.sideBarWidth = window.innerWidth;
                this.settingsFormFullWidth = true;

                if (! this.showSettings) {
                    this.setShowSettings(true);
                }
            }
        },
        /**
         * Hide settings
         */
        setShowSettings(flag) {
            this.showSettings = flag;
        }
    },
    async created() {
        this.dataProvider = new this.dataProviderClass(this.blueprintId, {verticalId: this.verticalId, settings: true});
        this.setShowSettingsDebounced = this.$debounce(this.setShowSettings, 80);

        await this.dataProvider.fetchInterfaceData();
        this.breakpoints = this.dataProvider.fetchSupportedBreakpoints();
        // set the original breakpoint as the active breakpoint
        this.activeBreakpointId = this.breakpoints.find(breakpoint => breakpoint.isOriginal).id;

        this.setSideBarWidthFromStorage();
        
        if (this.$route.params.relationString) {
            this.showSettings = true;
        }
    }
}, 'blueprints/bp-skin-settings.html');
